import { render, staticRenderFns } from "./RFQCardTransition.vue?vue&type=template&id=10e30bc6&"
import script from "./RFQCardTransition.vue?vue&type=script&lang=js&"
export * from "./RFQCardTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports